import { Dataset } from '../../../types/types';
import { getDataKey } from '../../../utils/getDataKey';
import {
  DatasetDataApiRequestData,
  SubsetDataApiRequestData,
} from '../../types/types';

// Context for resolving a `dataset` control's `data` templates: the source
// grid's request data + the selected row (`id` = the row's idItem value).
// Used only for template resolving, never sent as a request.
export const getDatasetControlDatasetActionTemplateData = (
  dataset: Dataset,
  currentRow: any | undefined,
  rowsToUse: any[],
  requestData: DatasetDataApiRequestData | SubsetDataApiRequestData
) => {
  // Navigation-only action — the template context never becomes a request
  const base: Record<string, unknown> = { ...requestData };
  delete base.limit;
  delete base.offset;
  delete base.sessionId;
  delete base.token;

  const dataKey = getDataKey(dataset);
  // Fall back to the single selected row when no row is expanded (mirrors
  // getDatasetControlMethodActionApiRequestData).
  const targetRow =
    currentRow ?? (rowsToUse.length === 1 ? rowsToUse[0] : undefined);

  return {
    ...base,
    id: targetRow ? targetRow[dataKey] : undefined,
    row: targetRow,
    ids: rowsToUse.map((row) => row[dataKey]),
    idItem: dataKey,
  };
};
